module.exports = __webpack_public_path__ + "img/about_elaine_cover.44d67ace.jpg";